export default __webpack_public_path__ + "card_de.a190c18a.png";